import SessionUser from './SessionUser';
import {UserFragment} from './Fragments';

SessionUser.UserFragment = UserFragment;

export default SessionUser;
